var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"firstDraft flex-center"},[_c('div',{staticClass:"tableStyle",domProps:{"innerHTML":_vm._s(_vm.content.news_content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }